import axios from 'axios';

/**
 * axios のデフォルト設定を JSON レスポンスタイプとトークンで行う
 *
 * @param {string} apiToken - APIトークン
 */
export const configureAxiosForJSON = apiToken => {
  axios.defaults.headers.common.Authorization = `Bearer ${apiToken}`;
  axios.defaults.responseType = 'json';
};

/**
 * axios のデフォルト設定を Blob レスポンスタイプとトークンで行う
 *
 * @param {string} apiToken - APIトークン
 */
export const configureAxiosForBlob = apiToken => {
  axios.defaults.headers.common.Authorization = `Bearer ${apiToken}`;
  axios.defaults.responseType = 'blob';
};
